// extracted by mini-css-extract-plugin
export default {"root":"LessonTableItem_root__n4B56","name":"LessonTableItem_name__cEGTA","info":"LessonTableItem_info__F5LpN"};